import { render, staticRenderFns } from "./lrQuery2.vue?vue&type=template&id=31200211&scoped=true&"
import script from "./lrQuery2.vue?vue&type=script&lang=js&"
export * from "./lrQuery2.vue?vue&type=script&lang=js&"
import style0 from "./lrQuery2.vue?vue&type=style&index=0&id=31200211&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31200211",
  null
  
)

export default component.exports